declare const I18n;

const DIFFICULTY_KEYS: Record<string, string> = {
  "1": "beginner",
  "2": "intermediate",
  "3": "advanced",
};

const getCourseDifficultyLabel = (level?: string | number | null): string => {
  if (level === undefined || level === null || level === "") {
    return "";
  }

  const difficultyKey = DIFFICULTY_KEYS[String(level)];
  if (!difficultyKey) {
    return String(level);
  }

  return I18n.t(`models.course.difficulty.${difficultyKey}`);
};

export default getCourseDifficultyLabel;
